export function buildUrlFromParts(parts) {
  const normalizedParts = parts
    .filter(Boolean)
    .map((part) => part.replace(/^\//g, ''))
    .map((part) => part.replace(/\/$/g, ''))
    .filter(Boolean);

  return ['', ...normalizedParts].join('/');
}
